export default __webpack_public_path__ + "static/media/Casamusica-large.eaedaebd.jpg";